import { render, staticRenderFns } from "./StatsGrid.vue?vue&type=template&id=cde85968&scoped=true&"
import script from "./StatsGrid.vue?vue&type=script&lang=js&"
export * from "./StatsGrid.vue?vue&type=script&lang=js&"
import style0 from "./StatsGrid.vue?vue&type=style&index=0&id=cde85968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde85968",
  null
  
)

export default component.exports